export default "__VITE_ASSET__c45dda9e__"